import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { toast } from 'react-toastify';
import api from '../../utils/api';

export const getAllVendorOrderThunk = createAsyncThunk(
    'order/getAllVendorOrderThunk',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getAllVendorOrder(config);
            //   console.log("nnnnn",response.data);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
);


export const getVendorOrderStatisticsThunk = createAsyncThunk(
    'order/getVendorOrderStatisticsThunk',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getVendorOrderStatistics(config);
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);


export const VendorOrderDetailsThunk = createAsyncThunk(
    'order/VendorOrderDetailsThunk',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.getVendorOrderDetails(id);
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);

export const exportVendorOrderThunk = createAsyncThunk(
    'order/exportVendorOrderThunk',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getAllVendorOrder(config);
              console.log(response.data?.data);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
);

export const deleteVendorOrderThunk = createAsyncThunk(
    'order/deleteVendorOrderThunk',
    async (id, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.deleteVendorOrder(id);
            dispatch(setVendorOrderrefresh())
            toast.success('order  deleted successfully')
            return response.data?.data;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'unable to delete order ')
        }
    }
);


export const updateOrderStatus = createAsyncThunk(
    'order/updateStatus',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.updateVendorOrderStatus(data);
            dispatch(setVendorOrderrefresh())
            toast.success('order updated  successfully')
            return response.status;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'unable to update order')
        }
    }
);

const VendorOrderSlice = createSlice({
    name: 'VendorOrder',
    initialState: {
        order:[],
        orderDetails: {},
        orderStatistics: {
            data: {},
            loading: false
        },
        refresh: false,
        loading: false,
        exportLoading: false,
        error: null,
        selectedTab: 0,
        page: 1,
        search: '',
        status: '',
        fromDate: '',
        toDate: '',
    },
    reducers: {

        setVendorOrderrefresh: (state, action) => {
            state.refresh = !state.refresh;
        },
        setVendorOrderPage: (state, action) => {
            state.page = action.payload
        },
        setVendorOrderSearch: (state, action) => {
            state.search = action.payload
        },
        setVendorOrderStatus: (state, action) => {
            state.status = action.payload
        },
        setVendorOrderFromDate: (state, action) => {
            state.fromDate = action.payload
        },
        setVendorOrderToDate: (state, action) => {
            state.toDate = action.payload
        },
        setVendorOrderSelectedTab: (state, action) => {
            state.selectedTab = action.payload
        },
        setVendorOrderData: (state, action) => {
            state.orderDetails = {
                ...state.orderDetails, // Keep existing fields
                products: action.payload, // Update only products
            };
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllVendorOrderThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAllVendorOrderThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.order = action.payload;
            })
            .addCase(getAllVendorOrderThunk.rejected, (state, action) => {
                state.loading = false;
            })

            //details
            .addCase(VendorOrderDetailsThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(VendorOrderDetailsThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.orderDetails = action.payload;
            })
            .addCase(VendorOrderDetailsThunk.rejected, (state, action) => {
                state.loading = false;
            })

            //details
            .addCase(exportVendorOrderThunk.pending, (state) => {
                state.exportLoading = true;
            })
            .addCase(exportVendorOrderThunk.fulfilled, (state, action) => {
                state.exportLoading = false;
            })
            .addCase(exportVendorOrderThunk.rejected, (state, action) => {
                state.exportLoading = false;
            })

            //statistics
            .addCase(getVendorOrderStatisticsThunk.pending, (state) => {
                state.orderStatistics.loading = true;
            })
            .addCase(getVendorOrderStatisticsThunk.fulfilled, (state, action) => {
                state.orderStatistics.loading = false;
                state.orderStatistics.data = action.payload
            })
            .addCase(getVendorOrderStatisticsThunk.rejected, (state, action) => {
                state.orderStatistics.loading = false
            })
    },
});

export const { setVendorOrderrefresh, setVendorOrderPage, setVendorOrderSearch, setVendorOrderStatus, setVendorOrderFromDate, setVendorOrderToDate, setVendorOrderSelectedTab, setVendorOrderData } = VendorOrderSlice.actions
export default VendorOrderSlice.reducer;

